import React, { useCallback } from 'react';
import { useAppDispatch } from 'flow/hooks/useRedux';
import { useModal } from 'flow/contexts/ModalProvider';
import { segmentTrack } from 'flow/actions/segment-actions';
import { TICKET_STRINGS } from 'flow/utils/segment-utils';
import TicketsListRelatedWrapper from 'flow/components/tickets/tickets-list/TicketsListRelatedWrapper';
import { TicketKey } from 'flow/types/EntityKeys';

interface Props {
    ticketKey: TicketKey;
    scrollableTargetId: string;
}

const RelatedTabContent = ({ ticketKey, scrollableTargetId }: Props) => {
    const dispatch = useAppDispatch();
    const { openModal } = useModal();

    const onTicketClicked = useCallback(
        (key: TicketKey) => {
            dispatch(
                segmentTrack(TICKET_STRINGS.USER_OPENED_RELATED_TICKET_MODAL, {
                    component: 'ticket page',
                }),
            );
            openModal('ticketOverview', {
                ticketKey: key,
                segmentContext: 'Related tickets',
            });
        },
        [dispatch, openModal],
    );

    return (
        <div className="pb-4">
            <TicketsListRelatedWrapper
                ticketKey={ticketKey}
                onClick={onTicketClicked}
                scrollableTargetId={scrollableTargetId}
            />
        </div>
    );
};

export default React.memo(RelatedTabContent);
